import { select } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApplicationUser } from '../../pb-screen/models/application.user.interface';
import { stat } from 'fs';
import { UsersAuthorizationService } from '../../users-authorizations/user-authorization.service';

@Injectable()
export class RedirectGuard implements CanActivate {
  constructor(private router: Router , private userAuthorizationService: UsersAuthorizationService) { 

  }
   
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean { 

    var screen = state.url.replace('/', ''); 
  if (this.userAuthorizationService.canAccessScreen(screen)){ 
      return true; 
    }
    else 
    {
      return false;
    }
  }
}